'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var observer = new MutationObserver(function (mutations) {
    if ((0, _functional.getElements)('.lion-history-table__row').length) {
      var showMoreBtn = context.getElement('.' + context.className + '_Btn');

      var totalPreviewRows = el.dataset.totalPreviewRows;
      var rows = (0, _functional.getElements)('.lion-history-table__row');
      var rowHeight = rows[0].offsetHeight;

      var table = context.getElement('.lion-history-table');
      var tableWrapper = context.getElement('.' + context.className + '_Table');
      var minimisedHeight = rowHeight * totalPreviewRows + rowHeight + 'px';

      if (rows.length > totalPreviewRows) {
        tableWrapper.style.height = minimisedHeight;
        showMoreBtn.style.display = 'block';

        showMoreBtn.addEventListener('click', function (e) {
          if (el.getAttribute('aria-expanded') === 'true') {
            el.setAttribute('aria-expanded', false);
            tableWrapper.style.height = minimisedHeight;
          } else {
            el.setAttribute('aria-expanded', true);
            tableWrapper.style.height = table.offsetHeight + 'px';
          }
        });
      }

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}